export default function Mentions({setIsMentionVisible}) { 
  return (
    <div id="container-mentions">
            <h2  >Mentions Légales</h2>
            <br />
            <h2  >Directeur de la publication :</h2>
            <p>POLARiS studio</p>
            <br />
            <h2  >Développement :</h2>

            <p>Ekleipsi Médias – Jonathan Joly<br/>
                Siège social : 19 rue Henri Matisse - 11110 Coursan<br/>
                Site internet : www.ekleipsi-medias.fr<br/>
                Email : contact@ekleipsi-medias.fr<br/>
                Téléphone : 07 52 06 80 98<br/>
                Siret : 84816771400015
            </p>
            <br />
            <h2  >Hébergement :</h2>
            <p>Site hébergé par 1and1<br/>
                Adresse postale : 1&1 Internet SARL 7, place de la Gare BP 70109.<br/>
                57201 Sarreguemines Cedex<br/>
                Tel : 0970 808 911 (appel non surtaxé)<br/>
                Fax au 03 87 95 99 72.<br/>
                Mail : support@1and1.fr<br/>
                Site : www.1and1.fr
            </p>
            <br />
            <h2  >En conséquence, POLARiS studio décline toute responsabilité :</h2>
            <ul className="list-disc list-inside">
              <li>pour toute interruption du site ;</li>
              <li>pour toute survenance de bogues ;</li>
              <li>pour toute inexactitude ou omission portant sur des informations disponibles sur ce site ; </li>
              <li>pour tout dommage résultant d’une intrusion frauduleuse d’un tiers ayant entraîné une modification des informations mises à la disposition sur le site.</li>
            </ul>
            <br />
            <br />

            <h2>Décharge de responsabilité</h2>
            <p>
              Alors que nous avons effectué toutes les démarches pour nous assurer
              de la fiabilité des informations contenues sur ce site internet,
              POLARiS studio ne peut encourir aucune responsabilité du fait
              d’erreurs, d’omissions, ou pour les résultats qui pourraient être
              obtenus par l’usage de ces informations. POLARiS studio n’est tenu
              que d’une obligation de moyens concernant les informations qu’il met
              à disposition des personnes qui accèdent à son site internet.
            <br />
              L’ensemble de ce site relève de la législation française et
              internationale sur le droit d’auteur et la propriété intellectuelle.
              Tous les droits de reproduction sont réservés, y compris pour les
              documents téléchargeables et les représentations iconographiques et
              photographiques. La reproduction de tout ou partie de ce site sur un
              support électronique quel qu’il soit est formellement interdite sauf
              autorisation expresse du directeur de la publication. – toutes les
              marques citées sont la propriété de leurs titulaires respectifs. –
              les articles L122-4 et L122-5 du Code de la propriété intellectuelle
              interdisent toute représentation ou reproduction, intégrale ou
              partielle, faites en dehors d’un usage privé. Toute représentation
              ou reproduction intégrale ou partielle de cette œuvre, fait par
              quelque procédé que ce soit, sans le consentement de l’éditeur ou
              les ayants droit est illicite et constitue une contrefaçon
              sanctionnée par les articles L335-2 et suivants du Code de la
              propriété intellectuelle.
            </p>
            <br />
            <h2  >Crédits photos :</h2>
            <p>POLARiS studio</p>
            <br />
            <h2  >CNIL</h2>
            <p>
              Vous disposez d’un droit d’accès, de modification, de rectification
              et de suppression des données qui vous concernent (art.34 de la loi
              « Informatique et Libertés » n° 78-17 du 16 janvier 1978). Pour
              l’exercer, adressez-vous à :
            </p>
            <p><a href="mailto:contact@polarisstudio.io" class="mail">contact@polarisstudio.io</a></p>
            <br />

            <a onClick={() => setIsMentionVisible(false)} class="btn_mentions"> FERMER</a>

          </div>
  );
}